import React, { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import urls from 'src/urls/search';

import Message from '../message/message';

import messages from './query-substituted-warning.i18n';
import * as styles from './query-substituted-warning.style';

export default class QuerySubstitutedWarning extends PureComponent<any> {
  render() {
    return (
      <styles.Container>
        <Message
          messages={[
            <FormattedMessage {...messages.querySubstituted} key="message" />,
            <a href={urls.external.docs} target="_blank" key="link">
              <FormattedMessage {...messages.learnMoreLink} />
            </a>,
          ]}
        />
      </styles.Container>
    );
  }
}
